export interface StatusOption {
  id: string;
  label: string;
  isArchived?: boolean;
}

export interface ValuationStatusTrackerProps {
  isFromModels?: boolean;
  statusOptions: StatusOption[];
  currentStatusId?: string;
  onStatusChange?: (statusId: string) => void;
  isLoading?: boolean;
  disabled?: boolean;
  isExpanded?: boolean;
  fixedHeight?: number | 'auto';
}

export enum StepStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  PENDING = 'pending',
}
